export default __webpack_public_path__ + "static/media/Dazzed-Medium.0b1fe1bd.otf";